const TICKETS_REFRESH_EVENT = "tickets:refresh";

export const requestTicketListsRefresh = (detail = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(TICKETS_REFRESH_EVENT, { detail }));
};

export { TICKETS_REFRESH_EVENT };
